import React from "react"
import style from "./Bars.module.scss"
import { BarListItemComponent } from "./BarListItem"
import { Bar, bars } from "../data/bars"
import { getAverageStar } from "../service/barMethods"
import cn from "classnames"
import { Badge, barBadges } from "../data/badges"
import { BadgeComponent } from "./Badge"
import { BarBadgeId } from "../data/enums"

enum SortType {
  Title,
  Stars,
}

export const BarsComponent: React.FC = () => {
  const barsWithInfo = bars.filter((bar) => bar.info)

  const [sortType, setSortType] = React.useState(SortType.Title)
  const [filters, setFilters] = React.useState<Badge[]>([])

  const toggleBadgeInfilter = (badge: Badge) => {
    if (filters.includes(badge)) {
      const newFilters = filters.filter((filter) => filter !== badge)
      setFilters(newFilters)
    } else {
      setFilters([...filters, badge])
    }
  }

  let barsSorted: Bar[] = []
  switch (sortType) {
    case SortType.Title:
      barsSorted = barsWithInfo.sort((a, b) => a.title.localeCompare(b.title))
      break
    case SortType.Stars:
      barsSorted = barsWithInfo.sort((a, b) => {
        const starsA = getAverageStar(a)
        const starsB = getAverageStar(b)
        return starsB - starsA
      })
      break
    default:
      break
  }

  const barBadgesSorted = barBadges.sort((a, b) =>
    a.title.localeCompare(b.title)
  )

  const barsFiltered = barsSorted.filter((bar) => {
    for (let index = 0; index < filters.length; index++) {
      const filterId = filters[index].id as BarBadgeId
      const barBadges = bar.info?.badges ?? []
      if (!barBadges.includes(filterId)) return false
    }
    return bar
  })

  return (
    <div className={style.barsComponent}>
      <div>
        <div className={style.controlsSort}>
          <h2>Сортировать по</h2>
          <span
            className={cn({ [style.selected]: sortType === SortType.Title })}
            onClick={() => {
              setSortType(SortType.Title)
            }}
          >
            По названию
          </span>
          <span
            className={cn({ [style.selected]: sortType === SortType.Stars })}
            onClick={() => {
              setSortType(SortType.Stars)
            }}
          >
            По рейтингу
          </span>
        </div>

        <div className={style.controlsFilter}>
          <div>
            <h2>Фильтровать по</h2>
            <div className={style.badgeList}>
              {barBadgesSorted.map((badge, index) => {
                return (
                  <span
                    className={cn({
                      [style.unselected]: !filters.includes(badge),
                      [style.selected]: filters.includes(badge),
                    })}
                    onClick={() => {
                      toggleBadgeInfilter(badge)
                    }}
                  >
                    <BadgeComponent badge={badge} key={index} />
                  </span>
                )
              })}
            </div>
          </div>
        </div>

        <div className={style.list}>
          {barsFiltered.map((bar, index) => (
            <BarListItemComponent
              key={index}
              bar={bar}
              image="extra"
              showStars
            />
          ))}
          {!barsFiltered.length && (
            <span className={style.emptyList}>
              Ничего не нашлось по таким фильтрам
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
